// in src/customRoutes.js
import { WholesalerSettingMailNotificationEdit } from "./pages/wholesaler_setting_mail_notification";

export default [
  {
    key: "wholesaler_setting_mail_notification",
    path: "/wholesalers/me/setting_mail_notification",
    component: WholesalerSettingMailNotificationEdit,
  },
];
